import React from 'react';

// project import
import FeatureSection from 'sections/landing/FeatureSection';
import VoiceInputSection from 'sections/landing/VoiceInputSection';
import BillingSupportSection from 'sections/landing/BillingSupportSection';
import ContactSection from 'sections/landing/ContactSection';
import { SEO, buildBreadcrumb } from 'hooks/useSeo';
import { PageUrl } from 'const/page-url';

// ==============================|| FEATURES PAGE ||============================== //
//
// 機能詳細(STEP 01〜06)の専用ページ。
//
// もとはトップページの中段に置いていたが、トップが縦に長くなりすぎて
// 決裁者が最後まで読み切れないため、詳細だけをこのページに切り出した。
// トップページ側は FeatureOverviewSection のカード一覧に留め、
// 「もっと詳しく知りたい人」だけをここへ誘導する。
//
// 内容はトップページに置いていたときと同一。セクションも同じものを再利用しており、
// 文言を変えるときは片方だけを直すということが起きない構成にしてある。
//
//   FeatureSection        STEP 01〜04  アセスメント 〜 モニタリング
//   VoiceInputSection     STEP 05      音声入力
//   BillingSupportSection STEP 06      加算・請求サポート
//   ContactSection        最終CTA。読み終えた人の行き先を用意する

const Features: React.FC = () => {
    return (
        <React.Fragment>
            <SEO
                title="機能詳細 | アセスメントからモニタリングまで | OHANA AI"
                description="OHANA AI の機能をSTEP 01〜06で詳しく紹介します。5領域のアセスメント、個別支援計画書の自動作成、モニタリング、音声入力による記録、加算算定と減算対策まで、児童発達支援・放課後等デイサービスの書類業務をどのように支援するかをご覧いただけます。"
                path={PageUrl.Features.urlWithSlash}
                jsonLd={buildBreadcrumb([{ name: '機能詳細', path: PageUrl.Features.urlWithSlash }])}
            />

            <FeatureSection />
            <VoiceInputSection />
            <BillingSupportSection />
            <ContactSection />
        </React.Fragment>
    );
};

export default Features;
